<mat-card>
    <mat-card-title>Excluir Usuário</mat-card-title>
    <form>
        <mat-form-field>
            <input matInput placeholder="E-mail"
                [(ngModel)]="user.email" name="email" disabled>
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Nome"
                [(ngModel)]="user.name" name="name" disabled>
        </mat-form-field>
    </form>
    <button mat-raised-button (click)="deleteUser()" color="warn">
        Excluir
    </button>
    <button mat-raised-button (click)="cancel()">
        Cancelar
    </button>
</mat-card>